import React, { useContext } from 'react';
import { FlowContext } from '../../core/flow-engine';
import ManualInstitutionReview from '../../components/ManualInstitutionReview/ManualInstitutionReview';
import PhoneNumber from '../../components/PhoneNumber/PhoneNumber';
import { MFBeaconButton } from '../../components/Beacon/BeaconComponents';
import styles from './styles.css';
import { generateGeneralTestID } from '../../generateAutomationTestIDs';

const ManualInstitutionReviewScreen = () => {
  const { next, back } = useContext(FlowContext);
  return (
    <div>
      <ManualInstitutionReview />
      <div className="button-container">
        <MFBeaconButton
          id="manualInstitutionReviewContinue"
          variant="primary"
          size="normal"
          onClick={next()}
          label="Continue"
          data-name={generateGeneralTestID(
            'CustodianInstitution',
            'ContinueButton'
          )}
        />
        <MFBeaconButton
          id="manualInstitutionReviewBack"
          variant="secondary"
          size="normal"
          onClick={back()}
          className="beacon-button-margin-override"
          label="Back"
          data-name={generateGeneralTestID(
            'CustodianInstitution',
            'BackButton'
          )}
        />
      </div>
      <PhoneNumber />
      <style jsx>{styles}</style>
    </div>
  );
};

export default ManualInstitutionReviewScreen;
